export default "__VITE_ASSET__DT7rTx9$__"